module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.companylist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "所属城市",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerTypeName",
      "label": "岗位名称",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "riskLevelName",
      "label": "风险级别",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkContent",
      "label": "检查内容",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isClose",
      "label": "状态",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isClose === "0") ? _c('div', [_c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("启用")])]) : _c('div', [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("禁用")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isClose == '0') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClose(scope.$index, scope.row)
            }
          }
        }, [_vm._v("禁用")]) : _vm._e(), _vm._v(" "), (scope.row.isClose == '1') ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleOpen(scope.$index, scope.row)
            }
          }
        }, [_vm._v("启用")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc7917b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav/gwCheckItem.vue
// module id = 844
// module chunks = 2